var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuyIco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.5543C1 17.9083 5.47696 22.2487 10.9996 22.2487C16.5222 22.2487 20.9993 17.9083 20.9993 12.5543C20.9993 7.20017 16.5222 2.85986 10.9996 2.85986C5.47696 2.85986 1 7.20017 1 12.5543Z",
    fill: "url(#paint0_radial_1426_2922)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3816 14.2602V19.4391L16.9547 16.1903V12.4233L13.3816 14.2602Z",
    fill: "url(#paint1_linear_1426_2922)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3816 9.29222L8.60119 11.7498V5.66943L5.02808 8.91824V16.1905L8.60119 19.4393V16.0524L16.9707 11.7498V8.91824H16.9547L13.3816 5.66943V9.29222Z",
    fill: "url(#paint2_linear_1426_2922)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1426_2922",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8328 13.4968) rotate(-48.8075) scale(10.4659 10.3736)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17BB05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146838,
    stopColor: "#17BB05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005701"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1426_2922",
    x1: 10.9996,
    y1: 58.9829,
    x2: 10.9996,
    y2: -10.7721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C7E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296964,
    stopColor: "#48B825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325137,
    stopColor: "#48B825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488827,
    stopColor: "#67F53D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500515,
    stopColor: "#67F53D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763104,
    stopColor: "#54D12C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770008,
    stopColor: "#54D12C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#348E15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1426_2922",
    x1: 10.9995,
    y1: 4.44465,
    x2: 10.9995,
    y2: 24.8404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C7E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.236049,
    stopColor: "#48B825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273166,
    stopColor: "#48B825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488827,
    stopColor: "#67F53D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500515,
    stopColor: "#67F53D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763104,
    stopColor: "#54D12C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770008,
    stopColor: "#54D12C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#348E15"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyIco);
export default __webpack_public_path__ + "static/media/buyIco.1189afd519b61118808be60929812fe5.svg";
export { ForwardRef as ReactComponent };